(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"] && !Shopify.designMode) return;
  try {
    
  class WelcomePopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      const key = 'kindred-welcome-popup';
      const days = parseInt(this.dataset.days, 10) || 14;
      const delay = (parseInt(this.dataset.delay, 10) || 8) * 1000;
      const forced = this.querySelector('[data-welcome-success], [data-welcome-error]');

      this.querySelectorAll('[data-welcome-close]').forEach((el) =>
        el.addEventListener('click', () => this.close(key, days))
      );
      this.dialog.addEventListener('cancel', () => this.remember(key, days));
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close(key, days);
      });
      this.querySelector('[data-welcome-copy]')?.addEventListener('click', (event) => {
        const code = this.querySelector('[data-welcome-code]')?.textContent?.trim();
        if (code && navigator.clipboard) navigator.clipboard.writeText(code).catch(() => {});
        event.currentTarget.textContent = '✓';
      });

      if (forced) {
        this.open();
        this.remember(key, 365);
        return;
      }
      if (this.hasAttribute('data-design-mode')) return;
      if (this.seenRecently(key)) return;
      this.timer = setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    close(key, days) {
      this.remember(key, days);
      if (this.dialog.open) this.dialog.close();
    }

    seenRecently(key) {
      try {
        const until = parseInt(localStorage.getItem(key), 10);
        return until && until > Date.now();
      } catch (error) {
        return false;
      }
    }

    remember(key, days) {
      try {
        localStorage.setItem(key, String(Date.now() + days * 86400000));
      } catch (error) {}
    }
  }

  if (!customElements.get('welcome-popup')) customElements.define('welcome-popup', WelcomePopup);

  } catch(e) { console.error(e); }
})();
})();
